import { KeyboardEvent } from 'react';

export const preventFormSubmissionOnPressEnter = (event: KeyboardEvent) => {
  if (event.key === 'Enter') {
    event.preventDefault();
  }
};
